<template>
    <div class="sidebarcontainer">
        <!--<font-awesome-icon size="2x" icon="chevron-left" class="chevron" :class="{inverted: visible}" @click="visible = !visible"/><br>-->
        <portal to="export">
            <div class="export">
                <div class="action" v-if="printable">
                    <font-awesome-icon @click="print" :icon="['fal', 'print']"/>
                </div>
                <div class="action" v-if="fileExport">
                    <font-awesome-icon @click="fileExport" :icon="['fal', 'file-export']"/>
                </div>
            </div>
        </portal>
        <portal to="sidebar">
            <slot/>
        </portal>
    </div>

</template>

<script>

export default {
    props: {
        beforePrint: {
            type: Function,
            default: null
        },
        printable: {
            type: Boolean,
            default: true
        },
        fileExport: {
            type: Function,
            default: null
        }
    },
    methods: {
        print(){
            if(this.beforePrint){
                this.beforePrint(print);
            }else{
                print();
            }
        }
    },
    mounted(){
        
    },
    data: function(){
        return {
            visible: true
        }
    }
}

</script>

<style lang="scss">
    @import "../colors.scss";
</style>
